export const NEXT = "NEXT";
export const BACK = "BACK";

export const SUBSCRIPTION_LOADED = "SUBSCRIPTION_LOADED";

export const FORM_UPDATED = "FORM_UPDATED";

export const ENTITIES_LOADED = "ENTITIES_LOADED";
export const ENTITIES_ADDED = "ENTITIES_ADDED";
export const ENTITY_SELECTED = "ENTITY_SELECTED";
export const ENTITY_DESELECTED = "ENTITY_DESELECTED";
export const ENTITY_UPDATED = "ENTITY_UPDATED";
export const ENTITY_CHECKED = "ENTITY_CHECKED";
export const ENTITY_UNCHECKED = "ENTITY_UNCHECKED";
export const TOGGLE_SELECT_ALL_ENTITIES = "TOGGLE_SELECT_ALL_ENTITIES";
export const ENTITY_ATTRIBUTES_LOAD_FAILED = "ENTITY_ATTRIBUTES_LOAD_FAILED";
export const ENTITY_ATTRIBUTE_LOADING_STARTED = "ENTITY_ATTRIBUTE_LOADING_STARTED";
export const TOGGLE_ENTITY_EDIT = "TOGGLE_ENTITY_EDIT";
export const ENTITY_NAME_CHANGED = "ENTITY_NAME_CHANGED";

export const RESET_RELATIONS_LOADED = "RESET_RELATIONS_LOADED";
export const RELATIONS_LOADED = "RELATIONS_LOADED";
export const RELATION_SELECTED = "RELATION_SELECTED";
export const RELATION_DESELECTED = "RELATION_DESELECTED";
export const TOGGLE_SELECT_ALL_RELATIONS = "TOGGLE_SELECT_ALL_RELATIONS";

export const CARDINALITY_CHANGED = "CARDINALITY_CHANGED";
export const SHOW_REFERENCE_ATTRIBUTE_TOGGLED = "SHOW_REFERENCE_ATTRIBUTE_TOGGLED";
export const REFERENCE_ATTRIBUTE_CHANGED = "REFERENCE_ATTRIBUTE_CHANGED";
export const INITIAL_REFERENCE_ATTRIBUTES_LOADED = "INITIAL_REFERENCE_ATTRIBUTES_LOADED";

export const ATTRIBUTES_LOADED = "ATTRIBUTES_LOADED";
export const ATTRIBUTE_SELECTED = "ATTRIBUTE_SELECTED";
export const ATTRIBUTE_DESELECTED = "ATTRIBUTE_DESELECTED";
export const ATTRIBUTES_ADDED = "ATTRIBUTES_ADDED";
export const ATTRIBUTE_TYPE_CHANGED = "ATTRIBUTE_TYPE_CHANGED";
export const ATTRIBUTE_PICKLIST_UPDATED = "ATTRIBUTE_PICKLIST_UPDATED";
export const TOGGLE_SELECT_ALL_ATTRIBUTES = "TOGGLE_SELECT_ALL_ATTRIBUTES";
export const TOGGLE_EDIT_ATTRIBUTE = "TOGGLE_EDIT_ATTRIBUTE";
export const ATTRIBUTE_NAME_CHANGED = "ATTRIBUTE_NAME_CHANGED";

export const SHOW_ADVANCED_CONFIGURATIONS = "SHOW_ADVANCED_CONFIGURATIONS";
export const HIDE_ADVANCED_CONFIGURATIONS = "HIDE_ADVANCED_CONFIGURATIONS";

export const UPDATE_PREVIOUS_SELECTED_ENTITY_NAME = "UPDATE_PREVIOUS_SELECTED_ENTITY_NAME";

export const FACED_ERROR = "FACED_ERROR";

export const RELATION_SWAP = "RELATION_SWAP";

export const DISPLAY_CHECKBOX_TOGGLED = "DISPLAY_CHECKBOX_TOGGLED";
export const TOGGLE_DISPLAY_CONFIGURATION_LOADED = "TOGGLE_DISPLAY_CONFIGURATION_LOADED";
export const TOGGLE_LOAD_EDIT_PAGE_CONFIGURATION = "TOGGLE_LOAD_EDIT_PAGE_CONFIGURATION";